import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import AjukanPage from "@/pages/AjukanPage";
import DashboardPage from "@/pages/DashboardPage";
import PasienPage from "@/pages/PasienPage";
import AntrianPage from "@/pages/AntrianPage";
import MasterDataPage from "@/pages/MasterDataPage";
import UsersPage from "@/pages/UsersPage";
import AuditLogPage from "@/pages/AuditLogPage";

const FullPageLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
    <div className="flex flex-col items-center gap-3">
      <div className="h-10 w-10 rounded-full border-4 border-[#00B9AD]/30 border-t-[#00B9AD] animate-spin" />
      <p className="text-sm text-slate-500">Memuat...</p>
    </div>
  </div>
);

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) return <FullPageLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

// Rawat Inap is read-only and only has the patient schedule, so its landing page is /pasien, not the Dashboard.
const Home = () => {
  const { user } = useAuth();
  if (user?.role === "rawat_inap") return <Navigate to="/pasien" replace />;
  return <DashboardPage />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/ajukan" element={<AjukanPage />} />
    <Route element={<Protected><Layout /></Protected>}>
      <Route path="/" element={<Home />} />
      <Route path="/pasien" element={<PasienPage />} />
      <Route path="/antrian" element={<Protected roles={["super_admin", "admin_iprjt", "case_manager", "petugas_admisi"]}><AntrianPage /></Protected>} />
      <Route path="/master-data" element={<Protected roles={["super_admin"]}><MasterDataPage /></Protected>} />
      <Route path="/pengguna" element={<Protected roles={["super_admin"]}><UsersPage /></Protected>} />
      <Route path="/audit-log" element={<Protected roles={["super_admin"]}><AuditLogPage /></Protected>} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
